import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom'

export function CustomDomainSlugGate({ expectedSlug }: { expectedSlug: string }) {
  const { slug } = useParams()

  if (slug !== expectedSlug) {
    return <CustomDomainRootRedirect slug={expectedSlug} />
  }

  return <Outlet />
}

export function CustomDomainRootRedirect({ slug }: { slug: string }) {
  const location = useLocation()

  return (
    <Navigate
      to={{ pathname: `/campanha/${slug}`, search: location.search, hash: location.hash }}
      replace
    />
  )
}
